import React from 'react';
import ProfilePicture from '../ProfilePicture';
import { MDBBtn } from 'mdb-react-ui-kit';
import { useDispatch } from 'react-redux';
import { setFollow } from '../../Pages/Home/action';
import { Link, useNavigate } from 'react-router-dom';
import style from './style.module.scss';

function Profile({profile, following, followers, setFollowers, followedBy, setFollowed, isHome, isEditing}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onClickFollow = () => {
    dispatch(setFollow('follow',profile.username));
    setFollowed(!followedBy)
    setFollowers(followers+1)
  }
  const onClickUnfollow = () => {
    dispatch(setFollow('unfollow',profile.username));
    setFollowed(!followedBy);
    setFollowers(followers-1)
  }
  const onClickProfilepic = () => {
      navigate('/settings/profile?profilepic=true');
  }
  const displayBtn = () =>{
    if (isHome) {
      return(
        <Link to={'/settings/profile'}>
          <MDBBtn className={style.editProfile}>Settings</MDBBtn>
        </Link>
      )
    }
    if (!followedBy) {
      return (
        <MDBBtn className={style.follow} onClick={onClickFollow}>Follow</MDBBtn>
      )
    }
    return (
        <MDBBtn className={style.unfollow} onClick={onClickUnfollow}>Unfollow</MDBBtn>
      )
  }
  const displayBtnCollection = () => {
    const getText = () => {
      if(isHome)
        return "My NFT Collection";
      return `${profile.name} NFT Collection`;
    }
    const generateLink = () => {
      if(isHome)
        return '/collection'
      return `/collection/${profile.username}`;
    }
    return(
      <Link to={generateLink()}>
        <MDBBtn className={style.nftButton}>{getText()}</MDBBtn>
      </Link>
    )
  }
  return (
    <div className={style.parent}>
      <div className={style.left}>
        <div className={style.leftChild}>
          <ProfilePicture url={profile.profilePicture} isHome={isHome} onClick={isHome? onClickProfilepic: ''} />
        </div>
        <h5 className={style.name}>{profile.name}</h5>
        <p className={style.username}>
          <b>
            <i>
              @{profile.username}
            </i>
          </b>
        </p>
        <div className={style.followers}>
          <h6 className='me-2'>{following} Following</h6>
          <h6>{followers} Followers</h6>
        </div>
        {displayBtn()}
        {/* {displayBtnCollection()} */}
      </div>
    </div>
  )
}

export default Profile